import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
import { SimpleModal } from '@livable/saas-react-components';
import { Utility } from './Utility';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
export const UnitOptsModal = observer(_ref => {
  let trigger = _ref.trigger,
    unitIndex = _ref.unitIndex;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const getInitialIds = () => {
    const arr = [];
    store.addNewProperty.utilitiesSetupV2.selectedUtilities.forEach(u => {
      if (store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.getOptOutUtilityIds(unitIndex, u.utilityId)) {
        arr.push(u.utilityId);
      }
    });
    return arr;
  };
  const _useState = useState([...getInitialIds()]),
    _useState2 = _slicedToArray(_useState, 2),
    initialIds = _useState2[0],
    setInitialIds = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  const handleSave = () => {
    setInitialIds([...getInitialIds()]);
    setIsOpen(false);
  };
  const handleCancel = () => {
    store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.saveDisabledOptOutUtilityIds(unitIndex, initialIds);
    setIsOpen(false);
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleCancel,
    handleOpen: () => setIsOpen(true),
    isOpen: isOpen,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      id: "saveUnitOptIns",
      onClick: handleSave,
      variant: "contained",
      'custom-attribute': '694-new-billing-module'
    }, t('add_new_property_flow.confirm_unit_opt_ins')),
    trigger: trigger,
    title: "".concat(t('general.unit'), " ").concat(store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].name, " ").concat(t('general.opt_ins')),
    variant: "middle"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.title')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('add_new_property_flow.opt_ins_hint')), /*#__PURE__*/React.createElement("div", null, store.addNewProperty.utilitiesSetupV2.selectedUtilities.map(utility => /*#__PURE__*/React.createElement(Utility, {
    utility: {
      title: utility.name,
      utilityProviderName: utility.utilityProviderName
    },
    key: utility.utilityId,
    utilityId: utility.utilityId,
    unitIndex: unitIndex
  }))));
});